export default "__VITE_ASSET__BFu0gsbo__"